// extracted by mini-css-extract-plugin
export var mailchimpSignupHolder = "MailchimpSignup-module--mailchimpSignupHolder--12xep";